/* eslint-disable require-jsdoc */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { ExportToCsv } from 'export-to-csv-fix-source-map';
import { Button } from '@simplybenefits/sb-ui-library';
import NotificationsList from './components/NotificationsList.js';
import FileDropZoneModal from '../../../../components/FileDropZoneModal.js';
import { uploadFile } from '../../../../actions/master.js';
import PermissionsComponent from '../../../../components/PermissionsComponent.js';

const styles = {
    header: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-end',
        marginBottom: '16px'
    }
};

const UPLOAD_CONFIG = {
    instructions: 'To notify the dentist to submit claims electronically, download the template, fill in the required columns using details from the paper dental claim form, save the file as a CSV, then upload it here. Required columns are "Patient First Name", "Patient Last Name", "Dentist First Name", "Dentist Last Name", "Unique Provider Number", "Postal Code", "Date of Service", "Total Fee Submitted", "Group Number", "Cert", and "Coordination".',
    templateData: {
        'Patient First Name': 'John',
        'Patient Last Name': 'Smith',
        'Dentist First Name': 'Jane',
        'Dentist Last Name': 'Doe',
        'Unique Provider Number': '123456',
        'Postal Code': 'V1Y 4H5',
        'Date of Service': '2024-05-01',
        'Total Fee Submitted': '150.00',
        'Group Number': '1001',
        'Cert': '12345',
        'Coordination': 'No'
    }
};

/**
 *
 * @returns {React.JSX.Element}
 * @constructor
 */
const ElectronicSubmissionRequests = ({ dispatch, accessType }) => {
    const [ modal, setModal ] = useState(false);
    const [ refreshKey, setRefreshKey ] = useState(false);

    const handleDownloadTemplate = () => {
        const options = {
            fieldSeparator: ',',
            filename: 'electronic submission template',
            quoteStrings: '"',
            decimalSeparator: '.',
            showLabels: true,
            showTitle: false,
            useTextFile: false,
            useBom: true,
            useKeysAsHeaders: true
        };
        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv([ UPLOAD_CONFIG.templateData ]);
    };

    const handleSubmitFile = async (files) => {
        const form = new FormData();
        await form.append('file', files[0]);

        await dispatch(uploadFile(form, 'electronicSubmissionRequests'));
        setRefreshKey((prev) => !prev);
    };

    return (
        <>
            <div style={styles.header}>
                <PermissionsComponent
                    permission="Electronic Submission Requests"
                    accessType={accessType}
                    level="read/write"
                >
                    <Button
                        color="primary"
                        onClick={() => setModal(true)}
                        customStyle={{
                            height: 40,
                            width: 165,
                            textTransform: 'none',
                            fontSize: 16
                        }}
                    >
                        Notify Dentist
                    </Button>
                </PermissionsComponent>
            </div>

            <NotificationsList refresh={refreshKey} />

            {
                modal &&
                    <FileDropZoneModal
                        title="Please select files"
                        showModal={modal}
                        hideModal={() => setModal(false)}
                        maxItems={1}
                        submitFile={handleSubmitFile}
                        instructions={UPLOAD_CONFIG.instructions}
                        acceptedFiles=".csv"
                        downloadTemplate={handleDownloadTemplate}
                    />
            }
        </>
    );
};

export default connect()(ElectronicSubmissionRequests);